module.exports = __webpack_public_path__ + "media/packs/images/flags/SB-4389db596f074941ff9ffdf037803823.png";